import 'leaflet/dist/leaflet.css';
import {MapContainer, TileLayer} from 'react-leaflet';
import RoutingMachine from './RoutingMachine';
import {Order, RouteStatus} from 'types';

type Props = {
  display: boolean;
  orders: Order[];
  routeType?: 'car' | 'bike';
  isHistory?: boolean;
  start_location: {
    name: string;
    lat: number;
    lng: number;
  };
  end_location: {
    name: string;
    lat: number;
    lng: number;
  };
  openedPopup?: {
    index: number;
    id: number;
  };
  markerClick?: (id: number) => void;
  status?: RouteStatus;
  driver?: {
    latitude: number;
    longitude: number;
  };
  driver_id?: number;
};

function NewMap({
  openedPopup,
  display,
  orders,
  start_location,
  isHistory,
  end_location,
  routeType,
  markerClick,
  driver,
  status,
  driver_id,
}: Props) {
  return (
    <div style={{position: 'relative', zIndex: 0}}>
      <MapContainer
        center={[40.7128, -74.006]}
        style={{
          height: isHistory ? 'calc(100vh - 5.5rem)' : 'calc(100vh - 4rem)',
        }}
        zoom={11}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <RoutingMachine
          driver_id={driver_id}
          openedPopup={openedPopup}
          status={status}
          markerClick={markerClick}
          start_location={start_location}
          end_location={end_location}
          orders={orders}
          isHistory={isHistory}
          display={display}
          routeType={routeType}
          driver={driver}
        />
      </MapContainer>
    </div>
  );
}

export default NewMap;
